// â”€â”€â”€ Email domain classifier (Â§5 of CONTACTS_DIRECTORY_ALGORITHM) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//
// Derives `isExternal` flag from email domain. Run on every contact write that
// touches the email field. Result stored on the contact doc â€” denormalized so
// pickers can filter without a function call per row.
//
// IMPORTANT: `isExternal` is a DOMAIN signal, NOT an employment signal.
// A field-staff `employee` with `@gmail.com` will have `isExternal: true` AND
// `user_type: 'employee'`. The two are independent. See plan D10.

import { COMPANY_DOMAINS } from '../types';
import { normalizeEmail } from './email';

export interface DomainClassification {
  /** Lowercased domain after the last `@`. */
  domain: string;
  /** `false` if domain âˆˆ COMPANY_DOMAINS whitelist; `true` otherwise. */
  isExternal: boolean;
}

/** Classify email domain. Throws on malformed email (no `@` or empty domain). */
export function classifyEmailDomain(email: string): DomainClassification {
  const norm = normalizeEmail(email);
  const at = norm.lastIndexOf('@');
  if (at < 0) {
    throw new Error(`Cannot classify domain â€” no '@' in email: ${email}`);
  }
  const domain = norm.slice(at + 1);
  if (!domain) {
    throw new Error(`Cannot classify domain â€” empty domain in email: ${email}`);
  }
  return {
    domain,
    isExternal: !COMPANY_DOMAINS.includes(domain),
  };
}
